import { Magazine } from "../Datatypes";
import dayjs from 'dayjs';
import isBetween from "dayjs/plugin/isBetween";
dayjs.extend(isBetween);

export const useFilterMagazines = (
  availableMagazines: Magazine[],
  dateFilter: string | null,
  editionFilter: string | null
): Magazine[] => {
  return availableMagazines.filter((m) => {
    const isDateMatch =
    !dateFilter ||
    dayjs(m.date).isBetween(
      dayjs(dateFilter).subtract(6, "day"),
      dayjs(dateFilter),
      "day",
      "[]"
    );
    const isEditionMatch = !editionFilter || m.edition === editionFilter;
    const isSonntag = m.edition === "SONNTAG";
    return isDateMatch && isEditionMatch || isDateMatch && isSonntag;
  });
};